module.exports = __webpack_public_path__ + "static/img/人员在岗识别.449c44b8.png";